import React from 'react';
import { ILearningCenterArticle } from '../../../../../types/contentful';
import { ArticleSnippet } from '../ArticleSnippet';
interface RelatedContentProps {
  relatedArticles?: ILearningCenterArticle[];
}

export function RelatedContent({
  relatedArticles,
  ...props
}: RelatedContentProps) {
  return relatedArticles ? (
    <section
      data-blockid="related-posts-container"
      data-testid="related-posts-container"
      className="z-10 flex h-fit w-full flex-col"
      {...props}
    >
      <h3 className="heading-3 mb-2 p-2 leading-8 tablet:p-4 tablet:text-[26px]">
        Related Content
      </h3>
      <div className="flex flex-col items-start gap-4 self-stretch [&>div]:h-[1px] [&>div]:bg-[#1A353826]">
        {relatedArticles.map(({ sys, fields }) => (
          <>
            <ArticleSnippet key={sys.id} showSummary={true} fields={fields} />
          </>
        ))}
      </div>
    </section>
  ) : null;
}
